
const MyBookings=require('./MyBookings.png')
const BookingsImages = {
    MyBookings
}

export default BookingsImages